import Cookies from "js-cookie";

export const isHiddenEnv = (): boolean => !!Cookies.get("hidden");
